import { render, staticRenderFns } from "./aboutLesson.vue?vue&type=template&id=a5eca218"
import script from "./aboutLesson.vue?vue&type=script&lang=js"
export * from "./aboutLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports